import React from 'react';
import {ExtendedGridGalleryBase, IGalleryAppProps} from '../../../common/ExtendedGridGallery/ExtendedGridGallery';
import {withGlobals} from '../../../globalPropsContext';
import {withTranslations} from '@wix/wixstores-client-common-components/dist/es/src/outOfIframes/translations';
import {withRepeatedSlotsPlaceholders} from '@wix/widget-plugins-ooi';

const CategoryPageAppComp: React.FC<IGalleryAppProps> = (props) => {
  return <ExtendedGridGalleryBase {...props} />;
};

export const CategoryPageApp = withRepeatedSlotsPlaceholders(withGlobals(withTranslations()(CategoryPageAppComp)));
